import { AbilityBuilder, Ability, detectSubjectType, AbilityClass, ConditionsMatcher, MatchConditions, PureAbility, } from "@casl/ability";
import _ from "lodash";

type Actions = "manage" | "create" | "read" | "update" | "delete" | string;
type Subjects = "User" | string | "all";

export type AppAbility = PureAbility<[Actions, Subjects], MatchConditions>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
const lambdaMatcher: ConditionsMatcher<MatchConditions> = (matchConditions) => matchConditions;

function getKeyValues(obj: any = {}, label: string = "", name: string = "", positions: any = []) {
  for (const key of Object.keys(obj)) {
    if (typeof obj[`${key}`] === "object") {
      const oldName = name;
      name = name ? `${name}.${key}` : `${key}`;
      getKeyValues(obj[`${key}`], label, name, positions);
      name = oldName;
    } else {
      const position = {
        position: `${label}.${name}`,
        label: label,
      };
      positions.push(position);
      return;
    }
  }
  return positions;
}

function getModuleRoles(permissions: any = [], roles: any = []) {
  for (const key of Object.keys(permissions)) {
    if (typeof permissions[`${key}`] === "object") {
      const role: any = getKeyValues(permissions[`${key}`], key);
      if (role && role.length) {
        roles = [...roles, ...role];
      }
    }
  }
  return roles;
}

function getRoles(permissions: any = []) {
  const permissionPositions: any = getModuleRoles(permissions);
  const roles: any = [];
  if (!permissionPositions || permissionPositions.length === 0) {
    return roles;
  }
  permissionPositions.forEach((position: any) => {
    const permission = _.get(permissions, `${position.position}`, {});
    const topicPermissions: any = [];
    Object.keys(permission).forEach((key) => {
      const obj: any = {};
      obj[key] = permission[key];
      topicPermissions.push(obj);
    });
    roles.push({
      topic: position.position,
      permissions: topicPermissions,
    });
  });
  return roles;
}

export default function defineRules(role: string, permissions: any = []) {
  console.log("===> ", role);
  const { can, build, cannot } = new AbilityBuilder<AppAbility>();
  if (permissions.isSuperAdminPermission) {
    can("manage", "all");
  } else {
    const roles = getRoles(permissions);
    roles.forEach((role: any) => {
      role.permissions.forEach((permission: any) => {
        Object.keys(permission).forEach((key) => {
          if (permission[key]) {
            can(key, role.topic);
          } else {
            cannot(key, role.topic);
          }
        });
      });
    });
  }
  return build({
    conditionsMatcher: lambdaMatcher,
    detectSubjectType: detectAppSubjectType,
  });
}

function detectAppSubjectType(subject?: Subjects) {
  return detectSubjectType(subject);
}

export function hasAccessFor(role: string, permissions: any = []): AppAbility { return defineRules(role, permissions); }
